/* eslint-disable @next/next/no-img-element */
import React from "react";
import { Image } from "@src/components/Image";
import { useRouter } from "@src/lib/router";

import { showVideoRestrictionsBottomSheetAction } from "@src/components/BottomSheets/store/actions.js";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getAwsAssets } from "@src/utils";
import RightAngleIcon from "@src/components/AccentIcons/RightAngleIcon";
import { newWebEngage } from "@src/utils/webEngageEvent";

import InfoIcon from "@src/components/AccentIcons/InfoIcon";

const CourseDetails = ({ data, openModal }) => {
  const { t } = useTranslation();
  const router = useRouter();
  const dispatch = useDispatch();

  const multipleValiditySelected = useSelector(
    (state) => state.overviewReducer.multipleValiditySelected
  );

  const isPurchased = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isPurchased
  );

  const renderCourseContentsDetails = () => {
    return (
      <>
        {data?.resources?.videos != 0
          ? data?.resources?.videos + " Video Lecture(s)"
          : null}
        {data?.resources?.tests != 0
          ? ", " + data?.resources?.tests + " Test(s)"
          : null}
        {data?.resources?.files != 0
          ? ", " + data?.resources?.files + " File(s)"
          : null}{" "}
      </>
    );
  };
  const handleModal = () => {
    openModal();
    newWebEngage("multiple_course_validity_click");
  };
  return (
    <div>
      <div className="CourseDetails__Validity">
        <div className="CourseDetails__Validity__Left">
          <Image
            src={getAwsAssets("ValidityIcon.svg", "content")}
            alt="s"
            height={24}
            width={24}
          />
        </div>
        <div className="CourseDetails__Validity__Right">
          <div className="CourseDetails__Validity__Right__Heading">
            {data?.durationText?.heading}
          </div>
          <div className="CourseDetails__Validity__Right__Description">
            {data?.durationText?.subHeading}
          </div>
          {multipleValiditySelected && isPurchased === 0 && (
            <div
              className="CourseDetails__Validity__Right__MultipleValididtyButton"
              onClick={handleModal}
            >
              {t(
                "components.tabs.overview.components.aboutCourse.changeCourseValidity",
                "Change course validity"
              )}
              <div className="CourseDetails__Validity__Right__RightIcon">
                <RightAngleIcon />
              </div>
            </div>
          )}
        </div>
      </div>
      {data?.resourseDataText?.heading && (
        <div
          className="CourseDetails__Material"
          onClick={() => {
            router.push(`/${router?.query?.courseId}/2`);
          }}
        >
          <div className="CourseDetails__Material__Left">
            <Image
              src={getAwsAssets("PlayContent.svg", "content")}
              alt="dsf"
              height={24}
              width={24}
            />
          </div>
          <div className="CourseDetails__Material__Middle">
            <div className="CourseDetails__Material__Middle__Heading">
              {data?.resourseDataText?.heading}
            </div>
            <div className="CourseDetails__Material__Middle__Description">
              {data?.resourseDataText?.subHeading}
            </div>
            {data?.videoDisclaimer?.heading ? (
              <div className="CourseDetails__Material__Middle__VideoRestrictions">
                <InfoIcon />{" "}
                <span
                  onClick={(e) => {
                    dispatch(showVideoRestrictionsBottomSheetAction(true));
                    e.stopPropagation();
                  }}
                >
                  {t(
                    "components.tabs.overview.components.aboutCourse.videoRestrictions",
                    "Video Restrictions"
                  )}
                </span>
              </div>
            ) : null}
          </div>
          <div
            className="CourseDetails__Material__Right"
            onClick={() => {
              router.push(`/${router?.query?.courseId}/2`);
            }}
          >
            <Image
              src={getAwsAssets("RightNav.svg", "content")}
              alt="c"
              height={10}
              width={10}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(CourseDetails);
